<h2 mat-dialog-title>{{data.title | translate}}</h2>
<mat-dialog-content class="mat-typography" [class.loading]="data.animation">
  <div class="dialog-text-wrapper">
    <div [innerHTML]="data.body | translate" [class]="textclass"></div>
    @if (countdownSeconds != null && minutes != null) {
      <div class="countdown">{{'overlay.countdown' | translate: {minutes: minutes, seconds: seconds} }}</div>
    }
  </div>
</mat-dialog-content>
